import {
  qiyuesuoCreateByCategoryWithoutBussiness,
  qiyuesuoAddSignatory,
  qiyuesuoContractCancel,
  qiyuesuoContractViewPageUrl
} from "../api/index";

import { uid } from "@szgc/plt-core-v2";

import { Message } from "element-ui";

let onReciveMessageFn: (e: MessageEvent) => any;
import ContractLockHtml from "./ContractLock.html";

export default class ContractLock {
  public visible: boolean = false;
  /**
   * 是否签章
   */
  public signed: boolean = false;

  private openedWindow!: Window | null;
  /**
   * 合同id
   */
  private constractId!: string;

  public ext: { attId: string; fileName: string; requestRelativeUri: string } = {
    attId: "",
    fileName: "",
    requestRelativeUri: ""
  };

  private onSigned: (params:Record<string,unknown>) => any;
  
  /**
 * 构造函数用于初始化签名对象
 * 
 * @param {Object} config - 配置对象
 * @param {string} config.signatoryUserName - 签名者的用户名（可选）
 * @param {string} config.attId - 附件ID（可选）
 * @param {string} config.fileName - 文件名（可选）
 * @param {string} config.requestRelativeUri - 请求的相对URI（可选）
 * @param {string} config.constractId - 合同ID（可选）
 * @param {Function} config.onSigned - 签名完成后的回调函数（可选）
 */
constructor({
    attId,
    fileName,
    requestRelativeUri,
    constractId,
    onSigned
  }: {
    signatoryUserName?: string;
    attId?: string;
    fileName?: string;
    requestRelativeUri?: string;
    constractId?: string;
    onSigned?: () => any;
  } = {}) {
    // 初始化附件ID，默认为空字符串
    this.ext.attId = attId || "";
    // 初始化文件名，默认为空字符串
    this.ext.fileName = fileName || "";
    // 初始化请求的相对URI，默认为空字符串
    this.ext.requestRelativeUri = requestRelativeUri || "";
    // 初始化合同ID，默认为空字符串
    this.constractId = constractId || "";
    // 初始化签名完成后的回调函数，默认为空函数
    this.onSigned = onSigned || (() => null);
  
    // 在窗口上绑定消息监听事件，用于接收签名完成的消息
    // 先移除已存在的消息监听事件，以防重复绑定
    window.removeEventListener("message", onReciveMessageFn, false);
    // 更新消息监听事件的处理函数
    onReciveMessageFn = this.onReciveMessage;
    // 绑定新的消息监听事件
    window.addEventListener("message", this.onReciveMessage.bind(this), false);
  }
  /**
   * 创建签章
   * @param data 文件对象
   * @param subject 文件主题
   * @returns
   */
  async createByCategory(data: { raw: File }, subject: string = ""): Promise<unknown | boolean> {
    const formData = new FormData();
    formData.append("file", data.raw);
    formData.append("reqToken", uid());
    formData.append("title", data.raw.name);
    formData.append("fileType", "pdf");
    formData.append("subject", subject);
    try {
      const { success, data, message } = await qiyuesuoCreateByCategoryWithoutBussiness(formData);

      if (!success) {
        Message.error(message);
        return;
      }
      this.ext.attId = data.uploadVo.fileId;
      this.ext.fileName = data.uploadVo.name;
      this.ext.requestRelativeUri = data.uploadVo.requestUri;
      this.constractId = data.constractId;
      return true;
    } catch (error) {
      console.error(error);
      Message.error("文件上传失败");
    }
  }
  /**
   * 添加单个签章人
   * @param signatoryUserName 签章人，此人在签章系统有账号并已经实名
   * @returns
   */
  async addSignatoryUserName(signatoryUserName: string) {
    try {
      if (!this.constractId) {
        Message.error("缺少constractId");
        return false;
      }
      if (!signatoryUserName) {
        Message.error("缺少签章人");
        return false;
      }
      const { success, data, message } = await qiyuesuoAddSignatory({
        constractId: this.constractId || "",
        signatoryUserName: signatoryUserName
      });

      if (!success) {
        Message.error(message);
        return false;
      }
      this.signed = false;
      this.openSignPage(data);
      return true;
    } catch (error) {
      console.error(error);
      Message.error("获取签章地址失败");
      return false;
    }
  }
  /**
   * @TODO 未实现，添加多个签章人
   */
  async addSignatoryByList() {
    console.log("未实现，添加多个签章人");
  }
  /**
   * 打开签章页面
   * @param signUrl 签章页面url
   */
  openSignPage(signUrl: string) {
    this.visible = true;
    const ContractLockHtmlRowUrl = URL.createObjectURL(new Blob([ContractLockHtml],{type:"text/html"}));
    const url = `${ContractLockHtmlRowUrl}`;
    this.openedWindow = window.open(url);
    if (!this.openedWindow) return;
    this.openedWindow.onload = () => {
      this.openedWindow && this.openedWindow.postMessage(
        {
          action: "SIGN_OPENED",
          data: {
            contractId: this.ext.attId,
            contractName: this.ext.fileName,
            signUrl: signUrl
          }
        },
        "*"
      );
    };
  }

  /**
   * 获取签章查看页面地址
   * @returns
   */
  async getContractViewPageUrl() {
    try {
      if (!this.constractId) {
        Message.error("缺少constractId");
        return false;
      }
      const { success, data, message } = await qiyuesuoContractViewPageUrl(this.constractId);
      if (!success) {
        Message.error(message);
        return false;
      }
      return data;
    } catch (error) {
      console.error(error);
      Message.error("获取电子查看签约页面地址失败");
      return false;
    }
  }
  /**
   * 打开签章页面
   */
  async viewContract() {
    const res = await this.getContractViewPageUrl();
    if (res) {
      window.open(res);
    }
  }

  /**
   * 下载签章文件
   * @returns
   */
  download(): boolean {
    if (!this.ext.requestRelativeUri) {
      Message.error("缺少ext.requestRelativeUri");
      return false;
    }
    const a = document.createElement("a");
    // console.log(this.ext);
    a.href = this.ext.requestRelativeUri;
    a.download = this.ext.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  }
  /**
   * 删除签章文件
   * @returns
   */
  async deleteContract() {
    try {
      if (!this.constractId) {
        Message.error("缺少constractId");
        return false;
      }
      const { success, message } = await qiyuesuoContractCancel(this.constractId);
      if (!success) {
        Message.error(message);
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      Message.error("删除电子签约失败");
      return false;
    }
  }
  onReciveMessage(e: MessageEvent): any {
    try {
      if (e.source !== this.openedWindow) return;
      const data = JSON.parse(e.data);
      if (data.action !== "SIGN_COMPLETE_SIGN") return;
      Message.success(data.label);
      this.openedWindow && this.openedWindow.close();
      this.signed = true;
      if (typeof this.onSigned === "function") {
        this.onSigned(data);
      }
    } catch (error) {
      console.error(error);
      Message.error("无效的消息");
      this.signed = false;
    }
  }
}

